import { createContext } from "react";
const vacationsContext = createContext();
export default vacationsContext;
